import React, { Component } from 'react';
import PropTypes from "prop-types";
import CheckboxConfigField from "../../components/fields/CheckboxConfigField";

class CheckboxConfigFieldContainer extends Component {

    handleCheckboxGroupFieldChange = ( id, value ) => {
        const {
            handleFieldChange,
            checkboxGroupId
        } = this.props;

        handleFieldChange("checkboxGroup" + checkboxGroupId, JSON.stringify(value))
    };

    render() {
        const {
            labels,
            formData,
            maxChecked,
            hasSelectAll,
            checkboxGroupId,
            checkboxGroupTitle
        } = this.props;

        const formValues = formData["checkboxGroup" + checkboxGroupId] ?
            JSON.parse(formData["checkboxGroup" + checkboxGroupId].value) : {};

        let values = {};

        labels.forEach( label => {
            values[label] = formValues[label]
        } );

        return <CheckboxConfigField
            values={values}
            maxChecked={maxChecked}
            handleFieldChange={this.handleCheckboxGroupFieldChange}
            hasSelectAll={hasSelectAll}
            title={checkboxGroupTitle}
        />;
    }
}

CheckboxConfigFieldContainer.propTypes = {
    labels: PropTypes.array,
    formData: PropTypes.object,
    handleFieldChange: PropTypes.func,
    checkboxGroupId: PropTypes.number,
    maxChecked: PropTypes.number,
    hasSelectAll: PropTypes.bool,
    checkboxGroupTitle: PropTypes.string
};

export default CheckboxConfigFieldContainer;
